module.exports = __webpack_public_path__ + "img/image6.741ca23f.png";